export enum DashboardStatusEnum {
  PENDING = 'Pending',
  READY_TO_START = 'Ready To Start',
  COMPLETE = 'Complete',
  NOT_REPORTING = 'Not Reporting',
}
